import { MapPin } from "lucide-react";
import { SERVICE_CITIES, COMPANY } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const ServiceArea = () => {
  return (
    <section id="service-area" data-testid="service-area-section" className="bg-white py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <span className="text-brick font-bold text-sm tracking-[0.18em] uppercase">Where We Work</span>
            <h2 className="mt-3 font-heading font-extrabold tracking-tight text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.03]">
              Proudly serving Michigan.
            </h2>
            <p className="mt-5 text-charcoal/60 text-base sm:text-lg leading-relaxed">
              Rooted in West Michigan and traveling statewide for the right project — from the lakeshore to up north
              and out to Detroit. If your town isn't listed, just give us a call.
            </p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {SERVICE_CITIES.map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center gap-1.5 rounded-full bg-lightgray border border-black/5 px-4 py-2 text-sm font-semibold text-charcoal"
                >
                  <MapPin className="w-3.5 h-3.5 text-brick" /> {c}
                </span>
              ))}
            </div>
            <a
              href={COMPANY.phoneHref}
              data-testid="service-area-call"
              className="mt-8 inline-flex rounded-full bg-brick hover:bg-brick-dark text-white font-bold px-7 py-3.5 transition-[background-color,transform] duration-200 hover:scale-[1.03]"
            >
              Call {COMPANY.phoneDisplay}
            </a>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-2xl overflow-hidden border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.08)] group">
              <iframe
                title="BBS Masonry service area map — Michigan"
                data-testid="service-area-map"
                src="https://www.google.com/maps?q=Grand+Rapids,+Michigan&z=7&output=embed"
                width="100%"
                height="480"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="grayscale group-hover:grayscale-0 transition-[filter] duration-500 block"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
